import { v4 as uuidv4 } from 'uuid';
import fetch from '../../../utils/fetch';
import { giftCodeURL } from 'endpoints';
import giftCodeSdk from '../../../services/gift-code-sdk';
import { startLoading, endLoading } from '../../../app-dux/app-dux';

/*******************************************************************************
 * Initial state
 */
const initialState = {
    giftCodes: [],
    countryData: [],
    awardCountry: null,
    levelData: [],
    billProfiles: []
};

/*******************************************************************************
 * Non-async action types
 */
export const SET_COUNTRY_DATA = 'CREATE_GIFT_CODES/SET_COUNTRY_DATA';
export const SET_AWARD_COUNTRY = 'CREATE_GIFT_CODES/SET_AWARD_COUNTRY';
export const SET_LEVEL_DATA = 'CREATE_GIFT_CODES/SET_LEVEL_DATA';
export const UPDATE_GIFT_CODES_DATA = 'CREATE_GIFT_CODES/UPDATE_GIFT_CODES_DATA';
export const DOWNLOAD_COMPLETE = 'CREATE_GIFT_CODES/DOWNLOAD_COMPLETE';

/*******************************************************************************
 * Reducer
 */
export default function giftCodesPageReducer( state = initialState, action ) {
    switch ( action.type ) {
        case SET_COUNTRY_DATA:
            return {
                ...state,
                countryData: action.countryData
            };

        case SET_AWARD_COUNTRY:
            return {
                ...state,
                awardCountry: action.awardCountry
            };

        case SET_LEVEL_DATA:
            return {
                ...state,
                levelData: action.levelData
            };
        case UPDATE_GIFT_CODES_DATA:
            const levelData = [ ...state.levelData ];
            const levelId = levelData.findIndex( l => l.levelName === action.levelName );
            levelData[ levelId ] = { ...levelData[ levelId ], noOfGiftCodes: action.value };

            return {
                ...state,
                levelData
            };

        default:
            return state;
    }
}

/*******************************************************************************
 * Action creators
 */

export function fetchCountries( awardId ) {
    return ( dispatch ) => {
        return giftCodeSdk.getAwardCountries( awardId )
            .then( ( countryData ) => {
                dispatch( setCountryData( countryData ) );
                if ( countryData.length === 0 ) {
                    dispatch( setAwardCountry( null ) );
                    dispatch( setLevelData( [] ) );
                } else {
                    dispatch( setAwardCountry( countryData[ 0 ] ) );
                    dispatch( fetchLevels( countryData[ 0 ].programNumber ) );
                }
            } )
            .catch( ( errors ) => {
                //TODO: ?
            } );
    };
}

export function fetchLevels( programNumber ) {
    return ( dispatch ) => {
        return giftCodeSdk.getProgramLevels( programNumber )
            .then( ( levels ) => {
                dispatch( setLevelData( levels ) );
            } )
            .catch( ( errors ) => {
                //TODO: ?
            } );
    };
}

export function generateGiftCodes( awardId, billProfiles ) {
    return ( dispatch, getState ) => {
        dispatch( startLoading() );
        const state = getState().bulkGiftCodesPage;
        const requestedBy = getState().app.user?.username;
        const countryCode = state.awardCountry.countryCode;
        const giftCodes = [];

        state.levelData.forEach( l => {
            for ( let i = 0; i < parseInt( l.noOfGiftCodes ); i++ ) {
                giftCodes.push( {
                    awardId: awardId,
                    giftCodeId: uuidv4(),
                    countryCode: countryCode,
                    levelName: l.levelName,
                    billProfiles: billProfiles,
                    requestedBy: requestedBy
                } );
            }
        } );

        return fetch( `${ giftCodeURL }/gift-codes`, {
            method: 'POST',
            headers: {
                'content-type': 'application/json',
                'accept-type': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                'x-accept-encoding': 'base64'
            },
            body: JSON.stringify( giftCodes )
        } )
            .then( ( res ) => {
                if ( res.ok ) {
                    res.text().then( ( data ) => {
                        dispatch( download( 'gift-codes.xlsx', data ) );
                    } );
                } else {
                    //TODO: ?
                }
            } ).finally( () => {
                dispatch( endLoading() );
            } );
    };
}

export function download( filename, data ) {
    if ( navigator.msSaveBlob ) {
        data = window.atob( data );
        const byteArrays = [];
  
        for ( let offset = 0; offset < data.length; offset += 512 ) {
            const slice = data.slice( offset, offset + 512 );
            
            const byteNumbers = new Array( slice.length );
            for ( let i = 0; i < slice.length; i++ ) {
                byteNumbers[ i ] = slice.charCodeAt( i );
            }
            
            const byteArray = new Uint8Array( byteNumbers );
            
            byteArrays.push( byteArray );
        }
  
        const blob = new Blob( byteArrays, { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' } );
        navigator.msSaveBlob( blob, filename );
    } else {
        const element = document.createElement( 'a' );
        element.setAttribute( 'href', 'data:text/plain;base64,' + data );
        element.setAttribute( 'download', filename );

        element.style.display = 'none';
        document.body.appendChild( element );

        element.click();

        document.body.removeChild( element );
    }
    return {
        type: DOWNLOAD_COMPLETE
    };
}

function setCountryData( countryData ) {
    return {
        type: SET_COUNTRY_DATA,
        countryData
    };
}

export function setAwardCountry( awardCountry ) {
    return {
        type: SET_AWARD_COUNTRY,
        awardCountry
    };
}

function setLevelData( levelData ) {
    return {
        type: SET_LEVEL_DATA,
        levelData
    };
}

export function updateNoOfGiftCodes( levelName, value ) {
    return {
        type: UPDATE_GIFT_CODES_DATA,
        levelName,
        value
    };
}